export default __webpack_public_path__ + "static/salesforce-e71a9f797d1781ede48a82047da36a12.png";